<template>
  <section class="bloc-chefs">
    <div class="bloc-chefs__wrapper">
      <ul class="bloc-chefs__list">
        <li v-for="(item, i) in content.items" :key="i">
          <router-link :to="item.link" class="link scroll-step js-scroll-show" :class="`show-delay-` + Math.round(Math.random() * 6) * 100">
            <img class="img" :src="require(`@/${item.img}`)">
            <div class="content-wrapper">
              <div class="content">
                <h3 class="name">{{ item.status }} {{ item.name }}</h3>
                <div class="infos"><span>{{ item.restaurant }}</span><span>{{ item.place }}</span></div>
              </div>

              <span class="discover">{{ content.link_text }}</span>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ChefsCmp',
  props: {
    content: {
      type: Object,
      required: true
    },
  },
}
</script>

<style lang="scss">
  .bloc-chefs {
    width: 100vw;
    background: $th-cherry;
    overflow: hidden;
    position: relative;

    &__wrapper {
     width: 100%;
    }

    &__list {
     display: flex;
     flex-wrap: wrap;

      li {
        width: calc(100% / 3);
        height: grid_m(3, 2);
        position: relative;

        @include media($from: small) {
          width: calc(100% / 6);
          height: grid(3.35, 2);
        }

        .link {
          display: block;
          width: 100%;
          height: 100%;

          .desktop & {
            &:hover {
              .content-wrapper {
                opacity: 1;
              }
            }
          }
        }

        .img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .content-wrapper {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background: rgba($color: $th-cherry, $alpha: 0.85);
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          padding: rem(10);
          opacity: 0;
          transition: opacity 0.3s $quad-ease-out;

          @include media($from: small) {
            padding: rem(15);
          }

          .content {
            .name {
              @include paragraph($type: 'normal-gotham', $color: $th-white, $uppercase: true);
            }

            .infos {
              @include paragraph($type: 'normal', $color: $th-white, $uppercase: false);
              margin-top: rem(14);

              span {
                display: block;
              }
            }
          }

          .discover {
            @include paragraph($type: 'small-2-gotham', $color: $th-gold, $uppercase: true);
            position: absolute;
            bottom: rem(20);
          }
        }
      }
    }
  }
</style>
